import * as React from "react"
import ImageContentCard from "components/partials/parts/image-content-card"
import { ImageContentCardData } from "types/image-content-card-data";

type SolidImageCardProps = {
    cards: ImageContentCardData[];
    headline?: string;
    largeHeadline?: boolean;
    columns: number;
};

const SolidImageCards: React.FC<SolidImageCardProps> = ({ headline = null, largeHeadline = false, cards, columns = 2 }) => {
    return (
        <div className="pattern pattern--solid-image-cards">
            <div className="container">
                {headline && <h2 className={`${largeHeadline ? 'section-title' : 'h1'} text-center`}>{headline}</h2>}
                <div className={`flex-grid-container flex-grid-container--${columns}up ${columns === 2 ? 'flex-grid-container--large-gutter' : ''}`}>
                    {cards.map((card, index) => (
                        <ImageContentCard key={index} {...card} />
                    ))}
                </div>
            </div>
        </div>
    );
};

export default SolidImageCards;